import "./AddToListDropdown.scss";

import * as React from "react";
import { OverlayTrigger, MenuItem, Tooltip, Button, Popover } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";

import CreateModal from "./../modals/CreateModal";
import ShoppingListActions from "shared/src/actions/ShoppingListActions";
import * as articleUtils from "../../../../utils/articleUtils";
import { trackAddItemToList, trackAddItemToListGA } from "shared/src/tracking/ListTrackingUtil";
import BaseComponent from "../../../general/BaseComponent";
import { saveRecentSearches } from "../../shared/RecentSearches";
import { connect } from "shared/src/stores/storeConnect";
import { ShoppingList } from "shared/src/types/ShoppingList";
import ShoppingListStore from "shared/src/stores/ShoppingListStore";

import { PageType } from "shared/src/types/PageType";
import { ZeroResultType } from "shared/src/types/ZeroResultType";

type Props = {
    createNewList: (name: string, globallyVisible: boolean, readOnlyForEmployees: boolean) => void;
    bettyVariantId: string;
    bettyBundleId: string;
    disabled: boolean;
    articleDeprecated: boolean;
    lists: ShoppingList[];

    // Fields just for tracking tags. TODO(FD) these should be wrapped in a struct
    eventId: string;
    trackingId: string;
    pageType: PageType;
    zeroResultType: ZeroResultType | undefined | null;
    listType: string;
    inContainer: boolean;
    marketplace: boolean;
    offerId: string | null | undefined;
    ownBrand: string | null | undefined;
    ropoRank?: number | null | undefined;
};

type State = {
    showModal: boolean;
};

export class DisconnectedAddToListDropdown extends BaseComponent<Props, State> {
    state = {
        showModal: false
    };

    openCreateModal = () => {
        this.setState({
            showModal: true
        });
    };

    closeModal = () => {
        this.setState({
            showModal: false
        });
    };

    onMenuItemSelect = (list: any, event: React.SyntheticEvent<any>) => {
        const eventId = this.props.eventId;
        const bettyBundleId = this.props.bettyBundleId;
        const trackingId = this.props.trackingId;
        const listType = this.props.listType || "unknown";
        const listName = list.name || "unknown";
        const pageType = this.props.pageType;
        const zeroResultType = this.props.zeroResultType;
        const inContainer = this.props.inContainer;
        const marketplace = this.props.marketplace;
        const offerId = this.props.offerId;
        const ownBrand = this.props.ownBrand;
        const ropoRank = this.props.ropoRank;
        trackAddItemToList(
            eventId,
            bettyBundleId,
            trackingId,
            pageType,
            zeroResultType,
            inContainer,
            listType,
            list.listId,
            listName,
            marketplace,
            offerId,
            ownBrand,
            ropoRank
        );
        trackAddItemToListGA(bettyBundleId);

        ShoppingListActions.addItem(list, this.props.bettyVariantId, this.props.bettyBundleId);
        (event.target as any).blur();
        saveRecentSearches();
    };

    onAlreadySelected = () => {
        // do nothing
    };

    // FIXME(FD) why does ESLint think this is a component? not sure

    renderMenuItem = (list: ShoppingList) => {
        const isCustomerAndCannotEditList = list.readOnly && SessionStore.isCustomer();
        const isEmployeeAndCannotEditList = list.readOnlyForEmployees && SessionStore.isEmployee();
        if (isCustomerAndCannotEditList || isEmployeeAndCannotEditList) {
            return undefined;
        }
        if (articleUtils.containsBettyBundleId(this.props.bettyBundleId, list.items)) {
            const tooltipAlreadyContained = (
                <Tooltip id={"exADDITEMTOLISTALREADYCONTAINEDTOOLTIPForArticle" + (this.props.bettyBundleId || "")}>
                    <FormattedMessage id="EX_ARTICLE_ALREADY_IN_LIST" />
                </Tooltip>
            );
            return (
                <OverlayTrigger placement="top" key={list.listId} overlay={tooltipAlreadyContained}>
                    <MenuItem onSelect={this.onAlreadySelected} disabled className="not-hover-item with-icon">
                        {list.name}
                        <span className="round-icon background-brand">
                            <i className="icon-check" />
                        </span>
                    </MenuItem>
                </OverlayTrigger>
            );
        }
        return (
            <MenuItem key={list.listId} onSelect={(eventkey: any, event?: any) => this.onMenuItemSelect(list, event)}>
                {list.name}
            </MenuItem>
        );
    };

    renderTooltip = () => {
        if (this.props.articleDeprecated) {
            return <FormattedMessage id="EX_CANNOT_ADD_ITEM_TO_LIST_TOOLTIP_DEPRECATED" />;
        }
        if (this.props.disabled) {
            return <FormattedMessage id="EX_CANNOT_ADD_ITEM_TO_LIST_TOOLTIP" />;
        }
        return <FormattedMessage id="EX_ADD_ITEM_TO_LIST_TOOLTIP" />;
    };

    render() {
        const tooltip = (
            <Tooltip id={"idEXADDITEMTOLISTTOOLTIPForArticle" + (this.props.bettyBundleId || "")}>
                {this.renderTooltip()}
            </Tooltip>
        );
        const disabled = this.props.disabled || this.props.articleDeprecated;
        // Use pointer-events-none, because otherwise the disabled button catches the mouse events and the popover
        // doesn't trigger. The extra div between OverlayTrigger and DropdownButton also seems to be necessary for this
        const className = disabled ? "pointer-events-none" : "";
        const menu = (
            <Popover
                className="mfcss_card-article-2--secondary-actions-addtolist-menu"
                id={"ex-add-to-list-popover-" + this.props.bettyBundleId}>
                <ul>
                    <MenuItem className="ex-create-modal-in-dropdown with-icon" onClick={this.openCreateModal}>
                        <FormattedMessage id="ORC_CREATE_NEW_LIST" />
                        <i className="icon-plus text-primary" />
                    </MenuItem>
                    {this.props.lists.length > 0 && <MenuItem divider />}
                    {this.props.lists.map(this.renderMenuItem)}
                </ul>
            </Popover>
        );
        return (
            <div className={"mfcss_card-article-2--secondary-actions-addtolist test-add-to-list-button"}>
                {this.state.showModal && (
                    <CreateModal
                        show
                        createNewList={this.props.createNewList}
                        onClose={this.closeModal}
                        container={this}
                    />
                )}
                <OverlayTrigger placement="bottom" overlay={menu} trigger={disabled ? [] : "click"} rootClose>
                    <OverlayTrigger placement="top" overlay={tooltip}>
                        <div>
                            <Button bsStyle="link" disabled={disabled} className={className}>
                                <i className="icon-list-add-to" />
                                <FormattedMessage id="EX_ADD_TO_LIST" />
                            </Button>
                        </div>
                    </OverlayTrigger>
                </OverlayTrigger>
            </div>
        );
    }
}

export const AddToListDropdown = connect(
    {
        stores: [[ShoppingListStore, (s: typeof ShoppingListStore) => ({ lists: s.getAllListsWithoutDynamicLists() })]]
    },
    DisconnectedAddToListDropdown
);
